import { createReducer, on } from '@ngrx/store';
import { ActiveLanguageInterface } from '../types';
import * as LanguageActions from './actions';

export const initialState: ActiveLanguageInterface = {
  activeLanguage: '',
};

export const ActiveLanguageReducers = createReducer(
  initialState,
  on(LanguageActions.setActiveLanguage, (state, action) => ({
    activeLanguage: action.activeLanguage,
  })),
);
